import { render, staticRenderFns } from "./Guest_review.vue?vue&type=template&id=5d69b736&scoped=true&"
import script from "./Guest_review.vue?vue&type=script&lang=js&"
export * from "./Guest_review.vue?vue&type=script&lang=js&"
import style0 from "./Guest_review.vue?vue&type=style&index=0&id=5d69b736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d69b736",
  null
  
)

export default component.exports